import { render, staticRenderFns } from "./BusinessLetters.vue?vue&type=template&id=1ba158a2&"
import script from "./BusinessLetters.vue?vue&type=script&lang=js&"
export * from "./BusinessLetters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports